module.exports = __webpack_public_path__ + "img/menu-earn-white.8d65705a.svg";